import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { CURRICULUM } from '../store/actionTypes';
import { Curriculum } from './models/curriculums';

export const curriculums = createApi({
  reducerPath: CURRICULUM,
  baseQuery,
  tagTypes: ['Curriculum'],
  endpoints: builder => ({
    curriculum: builder.query<Curriculum, { code: string; fields?: string; sessionStart?: string }>(
      {
        query: variables => ({
          document: gql`
            query GetCurriculumByCountryCode(
              $code: String!
              $fields: String
              $sessionStart: DateTime!
            ) {
              getCurriculumByCountryCode(
                code: $code
                fields: $fieldspwd
                sessionStart: $sessionStart
              ) {
                id
                educationalStages {
                  gradeLevels
                  stage {
                    description
                    language
                    text
                  }
                  _id
                }
                institutions {
                  name {
                    text
                    language
                    description
                  }
                  addresses {
                    township
                    country
                  }
                  _id
                }
                session {
                  end
                  start
                  terms
                }
                gradeLevels {
                  _id
                  equivalent
                  level {
                    text
                    language
                    description
                  }
                  topics
                }
              }
            }
          `,
          variables,
        }),
        transformResponse: (response: any) => response?.getCurriculumByCountryCode,
      },
    ),
    curriculums: builder.query<Curriculum[], { search?: string; sessionStart?: string }>({
      query: variables => ({
        document: gql`
          query GetCurriculums($page: Int, $limit: Int, $search: String, $sessionStart: DateTime) {
            getCurriculums(
              page: $page
              limit: $limit
              search: $search
              sessionStart: $sessionStart
            ) {
              country {
                code
              }
              institutions {
                _id
                addresses {
                  country
                  stateOrProvince
                  streetNumber
                  township
                  unitNumber
                  streetName
                }
                name {
                  language
                  text
                  description
                }
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getCurriculums,
    }),
  }),
});

export const {
  useCurriculumQuery,
  useLazyCurriculumQuery,
  useCurriculumsQuery,
  useLazyCurriculumsQuery,
} = curriculums;
